var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, customElement, css, property, html } from 'lit-element';
let KiwiCore = class KiwiCore extends LitElement {
    constructor() {
        super(...arguments);
        this.templateElem = document.createElement('full-screen');
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.addEventListener('pathnamechanged', this.pathnameChanged.bind(this));
        if (!this.application || !this.navigator) {
            console.error('no configuration');
            return;
        }
        // Spusteni aplikace
        this.pathnameChanged({
            detail: {
                oldPathname: "",
                newPathname: this.navigator.path()
            }
        });
        // zařazení template do aplikace
        (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(this.templateElem);
    }
    disconnectedCallback() {
        this.removeEventListener('pathnamechanged', this.pathnameChanged);
        this.disconnectedCallback();
    }
    setNavigator(navigator) {
        this.navigator = navigator;
    }
    setApplication(application) {
        this.application = application;
    }
    setTemplate(element) {
        this.templateElem = element;
    }
    updated(changedProperties) {
        if (changedProperties.has("viewName")) {
            // TODO: FIXME: vyvolani zmeny pohledu v danem view
            this.pathnameChanged({
                detail: {
                    oldPathname: this.navigator.path(),
                    newPathname: this.navigator.path()
                }
            });
        }
    }
    async pathnameChanged(e) {
        var _a;
        if (!this.application || !this.navigator) {
            // TODO: propagate error
            console.error('Navigator or Application hasn\'t been set');
            return;
        }
        const oldView = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('view-component');
        if (oldView) {
            // TODO: save config from component
            oldView.remove();
            const oldConfig = oldView.getConfig();
            // TODO: ulozit pro predchozi view
        }
        console.info(`navigate from "${e.detail.oldPathname}" to "${e.detail.newPathname}"`);
        const path = e.detail.newPathname;
        const viewComponent = this.application.views(path);
        const vfs = this.application.vfs();
        // TODO: jakou mít defaultní komponetu pro zobrazení???
        let viewName = this.viewName;
        if (!viewName) {
            viewName = "default";
        }
        let view = viewComponent[viewName];
        if (!view) {
            viewName = "default";
            view = viewComponent[viewName];
        }
        const element = await viewComponent[viewName].createView();
        element.id = 'view-component';
        element.setVFS(vfs);
        element.setAnalytics(this.application.analytics());
        element.setNavigator({
            push: (pathname) => {
                return this.navigator.push(pathname);
            },
            path: () => {
                return this.navigator.path();
            },
            goBack: () => {
                return this.navigator.goBack;
            },
            goHome: () => {
                return this.navigator.goHome();
            },
        });
        element.setConfig({});
        // Měním view pouze v šabloně
        this.templateElem.setContent(element);
    }
};
KiwiCore.styles = css `
  :host {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
  }
  * {
    padding: 0;
    margin: 0;
  }
`;
__decorate([
    property()
], KiwiCore.prototype, "viewName", void 0);
KiwiCore = __decorate([
    customElement('kiwi-core')
], KiwiCore);
export { KiwiCore };
export class WithNavbarWrap {
    async createView() {
        return document.createElement('with-navbar');
    }
}
let FullScreen = class FullScreen extends LitElement {
    constructor() {
        super(...arguments);
        this.path = '';
        this.homeUrl = '';
    }
    setContent(elem) {
        elem.slot = 'content-slot';
        // Musi se pouzivat this, protoze kdyby se pouzilo this.shadowRoot, tak se to vloží pod shadowRoot,
        // ale pro správné fungování slotů je potřeba aby to bylo na stejné úrovni jako je shadowRoot
        this.appendChild(elem);
    }
    render() {
        return html `<slot class="slot" name='content-slot'></slot>`;
    }
};
FullScreen.styles = css `
    :host {
      display: flex;
      flex-flow: column;
      align-items: center;
      width: 100%;
      height: 100%;
    }
  `;
__decorate([
    property()
], FullScreen.prototype, "navigator", void 0);
__decorate([
    property()
], FullScreen.prototype, "path", void 0);
__decorate([
    property()
], FullScreen.prototype, "homeUrl", void 0);
__decorate([
    property()
], FullScreen.prototype, "application", void 0);
FullScreen = __decorate([
    customElement('full-screen')
], FullScreen);
export { FullScreen };
//# sourceMappingURL=kiwi-core.js.map